import api from '@/api/api';
import moment from "moment";
import { FormatoGuia } from "@/Utils/Utils";

export default {

  namespaced: true,

  state: {
    objetoPosteriorConInfo: {
      remitenteDelEnvioTitular: "",
    },
    infoDocumentoCommercialInvoice: {
      taxIDDestinatario: "",
      Exporter: {
        nombre: '',
        telefono: '',
        companyName: '',
        razonSocial: '',

      },
      Consignee: {
        nombre: '',
        telefono: '',
        companyName: '',
        razonSocial: "",
        direccion: "",
        pais: "",

      },
      fraccionesIterables: [],
      fechaEnvio: "",
      guiaPrimerPaquete: "",
      fechaSuperior: "",
      fechaInferior: "",
      idRemitente: "",
      totalKilos: 0,
      totalUnidades: 0,
      totalPaquetes: 0,
    },
    infoDocumentoTMEC: {
      taxIDDestinatario: "",
      idRemitente: "",
      Certificador: {
        nombre: "",
        telefono: "",
        razonSocial: "",
      },
      Importador: {
        nombre: "",
        telefono: "",
        direccion: "",
      },
      fraccionesIterables: [],
    },
    infoDocumentoPackingList: {
      customerOrderNo: "",
      dateShipped: "",
      shipTo: "",
      awb: "",
      packlist: "",
      total: 0
    },
    infoDespues: {
      VALORESCHECKBOX: {
        VARIOSIMPORTADORES: "",
        IMPORTADORDESCONOCIDO: "",
        DISPONIBLEAUTORIDADESIMPORTADORAS: "",
        VARIOSPRODUCTORES: ""
      },
      DATOSPRODUCTOR: {
        nombre: "",
      }
    },
  },
  mutations: {
    chargeInfoDocumentoCommercialInvoice(state, datos) {
      //state.infoDocumentoCommercialInvoice = datos;
      state.infoDocumentoCommercialInvoice.Exporter.nombre = datos.REMITENTE.nombre.toUpperCase();
      state.infoDocumentoCommercialInvoice.Exporter.telefono = datos.REMITENTE.telefono;
      state.infoDocumentoCommercialInvoice.Exporter.razonSocial = datos.REMITENTE.razon_social.toUpperCase();
      state.infoDocumentoCommercialInvoice.Consignee.nombre = datos.DESTINATARIO.nombre.toUpperCase();
      state.infoDocumentoCommercialInvoice.Consignee.telefono = datos.DESTINATARIO.telefono;
      state.infoDocumentoCommercialInvoice.Consignee.razonSocial = datos.DESTINATARIO.razon_social.toUpperCase();
      let direccionFormatoYa = datos.DIRECCION[0].direccion + ' ' + datos.DIRECCION[0].municipio + ' ' + datos.DIRECCION[0].estado + ' ' + datos.DIRECCION[0].codigopostal;
      state.infoDocumentoCommercialInvoice.Consignee.direccion = direccionFormatoYa.toUpperCase()
      let paisConvertido = '';
      switch (datos.DIRECCION[0].pais) {
        case 'Estados Unidos':
          paisConvertido = 'UNITED STATES OF AMERICA';
          break;
        case 'México':
          paisConvertido = 'MEXICO';
          break;
        case 'Canadá':
          paisConvertido = 'CANADA';
          break;
        default:

          break;
      }
      state.infoDocumentoCommercialInvoice.Consignee.pais = paisConvertido;
      state.infoDocumentoCommercialInvoice.idRemitente = datos.REMITENTE.id;
      state.infoDocumentoCommercialInvoice.guiaPrimerPaquete = datos.PAQUETES.InfoPaquetes[0].guia;
      state.infoDocumentoCommercialInvoice.referenciaIPS = datos.REFERENCIA;


      let todasFracciones = [];
      let totalDePaquetes = 0;
      for (let i = 0; i < datos.PAQUETES.InfoPaquetes.length; i++) {
        for (let j = 0; j < datos.PAQUETES.InfoPaquetes[i].fa.length; j++) {
          datos.PAQUETES.InfoPaquetes[i].fa[j].noPaquete = i + 1;
          totalDePaquetes = i + 1;
          todasFracciones.push(datos.PAQUETES.InfoPaquetes[i].fa[j]);
        }

      }
      let todosLosKilos = 0;
      for (let i = 0; i < datos.PAQUETES.InfoPaquetes.length; i++) {
        todosLosKilos += parseFloat(datos.PAQUETES.InfoPaquetes[i].pesokg);

      }
      //aqui se quitan fracciones repetidas
      //este bloque se eliminó para ahora sí enlistar cada paquete con las fracciones que contiene
      const sinRepetir = JSON.parse(
        JSON.stringify(todasFracciones)
      ).reduce((a, b) => {
        if (a[b.id]) {
          a[b.id].cantidad = parseFloat(a[b.id].cantidad) + parseFloat(b.cantidad);
        } else a[b.id] = b;
        return a;
      }, {});

      //si se quiere mostrar fracciones sin agrupar usar todasFracciones, caso contrario usar sinRepetir
      const todasFraccionesSinRepetir = Object.values(sinRepetir);

      let totalCantidad = 0;
      if (todasFraccionesSinRepetir.length == 1) {
        totalCantidad = todasFraccionesSinRepetir[0].cantidad;
      } else {
        for (let i = 0; i < todasFraccionesSinRepetir.length; i++) {
          totalCantidad += parseFloat(todasFraccionesSinRepetir[i].cantidad);
        }

      }



      state.infoDocumentoCommercialInvoice.fraccionesIterables = todasFraccionesSinRepetir;
      //total unidades y total kilos se quedan exactamente igual para este nuevo cambio
      state.infoDocumentoCommercialInvoice.totalPaquetes = totalDePaquetes;
      state.infoDocumentoCommercialInvoice.totalUnidades = totalCantidad;
      state.infoDocumentoCommercialInvoice.totalKilos = todosLosKilos;

      let fechaEnvio = datos.FECHA.substring(0, 10);
      const myMomentObject = moment(fechaEnvio, 'DD-MM-YYYY');
      state.infoDocumentoCommercialInvoice.fechaSuperior = moment(myMomentObject).locale('en').format('ll');
      state.infoDocumentoCommercialInvoice.fechaInferior = moment(myMomentObject).locale('en').format('LL');
      state.infoDocumentoCommercialInvoice.fechaEnvio = datos.FECHA.substring(0, 10);


    },
    chargeInfoDespuesDocumento(state, datos) {
      state.infoDespues = datos;
    },
    chargeInfoInsertadaDespuesNuevoCambio(state, datos) {
      state.objetoPosteriorConInfo = datos;
    },
    chargeInfoDocumentoPackingList(state, datos) {
      let todasFracciones = [];
      let numPaquetes = 0;
      for (let i = 0; i < datos.PAQUETES.InfoPaquetes.length; i++) {
        numPaquetes++;
        for (let j = 0; j < datos.PAQUETES.InfoPaquetes[i].fa.length; j++) {
          datos.PAQUETES.InfoPaquetes[i].fa[j].noPaquete = i + 1;

          datos.PAQUETES.InfoPaquetes[i].fa[j].subtotal = +datos.PAQUETES.InfoPaquetes[i].fa[j].cantidad * +datos.PAQUETES.InfoPaquetes[i].fa[j].valor_unitario;
          todasFracciones.push(datos.PAQUETES.InfoPaquetes[i].fa[j]);
        }
      }
      state.infoDocumentoPackingList.shipTo = datos.DESTINATARIO.nombre.toUpperCase();
      state.infoDocumentoPackingList.customerOrderNo = datos.REFERENCIA;
      state.infoDocumentoPackingList.dateShipped = datos.FECHA.substring(0, 9);
      state.infoDocumentoPackingList.awb = FormatoGuia(datos.PAQUETES.InfoPaquetes[0].guia);

      let total = todasFracciones.reduce((a, b) => +a + b.subtotal, 0);
      // let total = todasFracciones.map(packItem => (+packItem.cantidad || 0) * (+packItem.valor_unitario || 0)).reduce((a, b) => a + b);

      // total = arregloSubtotales.reduce((a, b) => parseFloat(a) + parseFloat(b));


      state.infoDocumentoPackingList.total = total;
      let todasFraccionesPorEnvio = [];
      for (let i = 0; i < numPaquetes; i++) {
        todasFraccionesPorEnvio[i] = [];
        console.log('d', i);
      }
      console.log(todasFraccionesPorEnvio, 'primero');

      // esta seccion causa conflicto
      let conteo = 0;
      for (let i = 0; i < todasFracciones.length; i++) {
        if (i >= 1) {

          if (todasFracciones[i].noPaquete != todasFracciones[i - 1].noPaquete) {
            // console.log('si',todasFracciones[i].noPaquete,todasFracciones[i - 1].noPaquete);
            conteo++;
          }
        }
        console.log(todasFracciones[i]);
        todasFraccionesPorEnvio[conteo].push(todasFracciones[i]);

      }
      console.log(todasFraccionesPorEnvio, 'tfpe');
      //fin seccion conflicto



      // todasFraccionesPorEnvio=todasFracciones

      // infoDocumentoPackingList: {
      //   customerOrderNo: "",
      //   dateShipped: "",
      //   shipTo: "",
      //   awb: "",
      //   packlist: "",
      //   total: 0
      // },
    },
    chargeInfoDocumentoTMEC(state, datos) {
      let todasFracciones = [];
      for (let i = 0; i < datos.PAQUETES.InfoPaquetes.length; i++) {
        for (let j = 0; j < datos.PAQUETES.InfoPaquetes[i].fa.length; j++) {
          todasFracciones.push(datos.PAQUETES.InfoPaquetes[i].fa[j]);
        }

      }
      //aqui se quitan fracciones repetidas
      const sinRepetir = JSON.parse(
        JSON.stringify(todasFracciones)
      ).reduce((a, b) => {
        if (a[b.id]) {
          a[b.id].cantidad = parseFloat(a[b.id].cantidad) + parseFloat(b.cantidad);
        } else a[b.id] = b;
        return a;
      }, {});

      const todasFraccionesSinRepetir = Object.values(sinRepetir);

      let fechaEnvio = datos.FECHA.substring(0, 10);
      const myMomentObject = moment(fechaEnvio, 'DD-MM-YYYY');
      state.infoDocumentoTMEC.fechaEnvio = moment(myMomentObject).format('ll');
      state.infoDocumentoTMEC.fechaEnvioRango = moment(myMomentObject).locale('es-mx').format('ll') + ' - ' + moment(myMomentObject).locale('es-mx').add(6, 'M').format('ll');
      state.infoDocumentoTMEC.fraccionesIterables = todasFraccionesSinRepetir;
      state.infoDocumentoTMEC.Certificador.nombre = datos.REMITENTE.nombre.toUpperCase();
      state.infoDocumentoTMEC.Certificador.razonSocial = datos.REMITENTE.razon_social.toUpperCase();
      state.infoDocumentoTMEC.Certificador.telefono = datos.REMITENTE.telefono;
      state.infoDocumentoTMEC.idRemitente = datos.REMITENTE.id;
      //destianatario
      state.infoDocumentoTMEC.Importador.nombre = datos.DESTINATARIO.nombre.toUpperCase();
      state.infoDocumentoTMEC.taxIDDestinatario = datos.DESTINATARIO.tax_id;
      state.infoDocumentoTMEC.Importador.telefono = datos.DESTINATARIO.telefono;
      state.infoDocumentoTMEC.Importador.direccion = datos.DIRECCION[0].direccion.toUpperCase() + '  ' + datos.DIRECCION[0].colonia.toUpperCase() + ' ' + datos.DIRECCION[0].codigopostal.toUpperCase() + ' ' + datos.DIRECCION[0].municipio.toUpperCase() + '  ' + datos.DIRECCION[0].estado.toUpperCase();
    },
    destroyInfoDocumentos(state) {
      state.infoDespues = {
        VALORESCHECKBOX: {
          VARIOSIMPORTADORES: "",
          IMPORTADORDESCONOCIDO: "",
          DISPONIBLEAUTORIDADESIMPORTADORAS: "",
          VARIOSPRODUCTORES: ""
        },
        DATOSPRODUCTOR: {
          nombre: "",
        }
      };
      state.infoDocumentoPackingList = {
        customerOrderNo: "",
        dateShipped: "",
        shipTo: "",
        awb: "",
        packlist: "",
        total: 0
      },
        state.objetoPosteriorConInfo = { remitenteDelEnvioTitular: "" };
      state.infoDocumentoCommercialInvoice = {
        idRemitente: "",
        taxIDDestinatario: "",
        Exporter: {
          nombre: '',
          telefono: '',
          razonSocial: "",

        },
        Consignee: {
          nombre: '',
          telefono: '',
          companyName: '',
          razonSocial: "",
          direccion: "",
          pais: "",

        },
        fraccionesIterables: [],
        fechaEnvio: "",
        guiaPrimerPaquete: "",
        fechaSuperior: "",
        fechaInferior: "",
        totalKilos: 0,
        totalUnidades: 0,
        totalPaquetes: 0,
      };
      state.infoDocumentoTMEC = {
        idRemitente: "",
        taxIDDestinatario: "",
        fraccionesIterables: [],
        Certificador: {
          nombre: "",
          telefono: "",
          razonSocial: "",
        },
        Importador: {
          nombre: "",
          telefono: "",
          direccion: "",
        },
      };
    },
  },
  actions: {
    async chargeInfoDocumento({ commit }, info) {
      if (info.tipoDocumento == 'CommercialInvoice') {

        commit('chargeInfoDocumentoCommercialInvoice', info.informacion);
        commit('chargeInfoDocumentoTMEC', info.informacion);
        commit('chargeInfoDocumentoPackingList', info.informacion);


      }

      if (info.informacion.DIRECCION_REMITENTE) {
        if (info.informacion.DIRECCION_REMITENTE[0]) {
          commit('chargeInfoInsertadaDespuesNuevoCambio', { direccionRemitente: info.informacion.DIRECCION_REMITENTE[0], remitenteDelEnvioTitular: info.informacion.TITULAR });
        }
      } else {
        commit('chargeInfoInsertadaDespuesNuevoCambio', { direccionRemitente: null, remitenteDelEnvioTitular: info.informacion.TITULAR });
      }

    },


    async chargeInfoDespuesDocumento({ commit }, info) {
      await commit('chargeInfoDespuesDocumento', info);
    },
    async destroyInfoDocumentos({ commit }) {
      await commit('destroyInfoDocumentos');
    },
  },
};
